import type { Palette, Theme } from './types';
import { buildPalettes, getColorByKey, pureBlack, pureWhite } from './utils';

const Transparent = 'transparent';
const White = getColorByKey('edgeless/palette/white');
const Black = getColorByKey('edgeless/palette/black');

const Light = {
  '红色': getColorByKey('edgeless/palette/light/redLight'),
  '橙色': getColorByKey('edgeless/palette/light/orangeLight'),
  '黄色': getColorByKey('edgeless/palette/light/yellowLight'),
  '绿色': getColorByKey('edgeless/palette/light/greenLight'),
  '蓝色': getColorByKey('edgeless/palette/light/blueLight'),
  '紫色': getColorByKey('edgeless/palette/light/purpleLight'),
  '洋红': getColorByKey('edgeless/palette/light/magentaLight'),
  '灰色': getColorByKey('edgeless/palette/light/greyLight'),
} as const;

const Medium = {
  '红色': getColorByKey('edgeless/palette/medium/redMedium'),
  '橙色': getColorByKey('edgeless/palette/medium/orangeMedium'),
  '黄色': getColorByKey('edgeless/palette/medium/yellowMedium'),
  '绿色': getColorByKey('edgeless/palette/medium/greenMedium'),
  '蓝色': getColorByKey('edgeless/palette/medium/blueMedium'),
  '紫色': getColorByKey('edgeless/palette/medium/purpleMedium'),
  '洋红': getColorByKey('edgeless/palette/medium/magentaMedium'),
  '灰色': getColorByKey('edgeless/palette/medium/greyMedium'),
} as const;

const Heavy = {
  '红色': getColorByKey('edgeless/palette/heavy/red'),
  '橙色': getColorByKey('edgeless/palette/heavy/orange'),
  '黄色': getColorByKey('edgeless/palette/heavy/yellow'),
  '绿色': getColorByKey('edgeless/palette/heavy/green'),
  '蓝色': getColorByKey('edgeless/palette/heavy/blue'),
  '紫色': getColorByKey('edgeless/palette/heavy/purple'),
  '洋红': getColorByKey('edgeless/palette/heavy/magenta'),
} as const;

const NoteBackgroundColorMap = {
  '黄色': getColorByKey('edgeless/note/yellow'),
  '橙色': getColorByKey('edgeless/note/orange'),
  '红色': getColorByKey('edgeless/note/red'),
  '洋红': getColorByKey('edgeless/note/magenta'),
  '紫色': getColorByKey('edgeless/note/purple'),
  '蓝色': getColorByKey('edgeless/note/blue'),
  '深绿色': getColorByKey('edgeless/note/teal'),
  '绿色': getColorByKey('edgeless/note/green'),
  '黑色': getColorByKey('edgeless/note/black'),
  '灰色': getColorByKey('edgeless/note/grey'),
  '白色': getColorByKey('edgeless/note/white'),
  '透明': Transparent,
} as const;

const Palettes: Palette[] = [
  // Light
  ...buildPalettes(Light, 'Light'),

  { key: '透明', value: Transparent },

  // Medium
  ...buildPalettes(Medium, 'Medium'),

  { key: '白色', value: White },

  // Heavy
  ...buildPalettes(Heavy, 'Heavy'),

  { key: '黑色', value: Black },
] as const;

const NoteBackgroundColorPalettes: Palette[] = [
  ...buildPalettes(NoteBackgroundColorMap),
] as const;

const StrokeColorShortMap = { ...Medium, '黑色': Black, '白色': White } as const;

const StrokeColorShortPalettes: Palette[] = [
  ...buildPalettes(StrokeColorShortMap),
] as const;

const FillColorShortMap = { ...Medium, '黑色': Black, '白色': White, '透明': Transparent } as const;

const FillColorShortPalettes: Palette[] = [
  ...buildPalettes(FillColorShortMap),
] as const;

const ShapeTextColorShortMap = {
  ...Medium,
  Black: pureBlack,
  White: pureWhite,
} as const;

const ShapeTextColorShortPalettes: Palette[] = [
  ...buildPalettes({ ...ShapeTextColorShortMap }),
] as const;

const ShapeTextColorPalettes: Palette[] = [
  // Light
  ...buildPalettes(Light, 'Light'),

  { key: '透明', value: Transparent },

  // Medium
  ...buildPalettes(Medium, 'Medium'),

  { key: '白色', value: pureWhite },

  // Heavy
  ...buildPalettes(Heavy, 'Heavy'),

  { key: '黑色', value: pureBlack },
] as const;

export const DefaultTheme: Theme = {
  pureBlack,
  pureWhite,
  black: Black,
  white: White,
  transparent: Transparent,
  textColor: Medium.蓝色,
  shapeTextColor: pureBlack,
  shapeStrokeColor: Medium.黄色,
  shapeFillColor: Medium.黄色,
  connectorColor: Medium.灰色,
  noteBackgrounColor: NoteBackgroundColorMap.白色,
  // 30% transparent `Medium.Blue`
  hightlighterColor: '#84cfff4d',
  Palettes,
  ShapeTextColorPalettes,
  NoteBackgroundColorMap,
  NoteBackgroundColorPalettes,
  StrokeColorShortMap,
  StrokeColorShortPalettes,
  FillColorShortMap,
  FillColorShortPalettes,
  ShapeTextColorShortMap,
  ShapeTextColorShortPalettes,
} as const;
